<template>
	<div class="grid grid-cols-12 px-8 md:px-24" :style="cssVariables">
		<div class="col-span-10 md:col-span-9">
			<h3 class="two-column-header">
				<slot name="header"></slot>
			</h3>
		</div>
		<div class="col-span-2 md:col-span-3">
			<div class="two-column-icon-wrapper">
				<slot name="icon"></slot>
			</div>
		</div>
		<div class="col-span-12">
			<div class="two-column-content" v-if="hasSlotContent">
				<slot name="content"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'two-column-content-icon',
	props: {
		bgColor: String,
		textColor: {
			type: String,
			default: '#292637'
		}
	},
	computed: {
		hasSlotContent () {
			return this.$slots.content
		},
		cssVariables() {
			return {
				'--bg-color': this.bgColor,
				'--text-color': this.textColor
			}
		}
	}
}
</script>

<style lang="postcss" scoped>
	.grid {
		background-color: var(--bg-color);
		color: var(--text-color);
	}
	.two-column-header, .two-column-content {
		text-align: left;
	}
	.two-column-header {
		font-family: theme('fontFamily.arial-bold');
		font-size: 1.25rem;
	}
	.two-column-content {
		padding: 0.5rem 0;
	}
	.two-column-icon-wrapper {
		font-size: 1.25rem;
	}
	@media screen and (min-width: 640px) {
		.two-column-header {
			font-size: 1.5rem;
		}
		.two-column-content {
			padding: 1rem 0;
		}
		.two-column-icon-wrapper {
			display: flex;
			justify-content: flex-end;
			font-size: 1.5rem;
		}
	}
</style>